module.exports = __webpack_public_path__ + "static/media/archived-grey.82bddfaa.svg";